import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import ScrollReveal from 'components/ScrollReveal';
import { ChevronDown } from 'lucide-react';

const FAQPage = () => {
  const { t } = useTranslation();

  const faqs = t('faq.items', {
    returnObjects: true,
  });

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className='min-h-screen bg-white'>
      <Navbar />

      <div className='max-w-4xl px-6 pt-24 pb-24 mx-auto md:px-8 md:pt-28 md:pb-28'>
        {/* HEADER */}

        <ScrollReveal>
          <div className='mb-12 md:mb-14'>
            <p
              className='
              text-red-500
              uppercase
              tracking-[0.2em]
              text-xs
              mb-3
              font-medium
              '
            >
              {t('faq.label')}
            </p>

            <h1
              className='
              text-[28px]
              sm:text-[36px]
              md:text-[44px]
              lg:text-[48px]
              font-semibold
              leading-tight
              tracking-tight
              mb-5
              '
            >
              {t('faq.title')}
            </h1>

            <p className='max-w-xl text-sm leading-relaxed text-neutral-600 md:text-base'>
              {t('faq.desc')}
            </p>
          </div>
        </ScrollReveal>

        {/* FAQ LIST */}

        <div className='space-y-3 md:space-y-4'>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <ScrollReveal key={index} delay={index * 0.04}>
                <div className='overflow-hidden transition border border-neutral-200 rounded-xl'>
                  {/* QUESTION */}

                  <button
                    onClick={() => toggle(index)}
                    className='flex items-center justify-between w-full px-5 py-4 text-left transition bg-white md:px-6 md:py-5 hover:bg-neutral-50'
                  >
                    <span className='pr-4 text-sm font-medium leading-relaxed text-neutral-900 md:text-base'>
                      {faq.question}
                    </span>

                    <ChevronDown
                      size={18}
                      className={`
                      flex-shrink-0
                      transition
                      duration-300
                      ${isOpen ? 'rotate-180' : ''}
                      `}
                    />
                  </button>

                  {/* ANSWER */}

                  <div
                    className={`
                    grid
                    transition-all
                    duration-300
                    ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}
                    `}
                  >
                    <div className='overflow-hidden'>
                      <p className='px-5 py-5 text-sm leading-relaxed md:px-6 md:pb-6 md:text-base text-neutral-600'>
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default FAQPage;
